import { QuestionCancelPolicy } from "@/components/features/items/edit/_shared/ui/components/main/questions/cancel-policy";

import { useOptionCancelPolicy } from "./hooks";

export const QuestionOptionCancelPolicy = () => {
	const {
		cancelPolicy,
		useBaseCancelPolicy,
		toggleUseBaseCancelPolicy,
		append,
		removeCancelPolicyByIndex,
		beforeDaysOptions,
		updateBeforeDays,
		chargeRatioOptions,
		updateChargeRatio,
	} = useOptionCancelPolicy();

	const guide = `オプション独自のキャンセルポリシーが設定できます。<br />`;

	return (
		<QuestionCancelPolicy
			cancelPolicy={cancelPolicy}
			useBaseCancelPolicy={useBaseCancelPolicy}
			toggleUseBaseCancelPolicy={toggleUseBaseCancelPolicy}
			appendCancelPolicy={append}
			removeCancelPolicy={removeCancelPolicyByIndex}
			cancelPolicyBeforeDaysOptions={beforeDaysOptions}
			changeCancelPolicyBeforeDays={updateBeforeDays}
			cancelPolicyChargeRatioOptions={chargeRatioOptions}
			changeCancelPolicyChargeRatio={updateChargeRatio}
			hasError={cancelPolicy?.hasError}
			isEdited={cancelPolicy?.isEdited}
			guide={guide}
		/>
	);
};

QuestionOptionCancelPolicy.displayName = "QuestionOptionCancelPolicy";
